export class DateFilter {
    public greaterThan?: Date;
    public lessThan?: Date;
    public equal?: Date[];
}
